import React, { Component } from 'react'
import { Form } from 'redux-form'
import { Dots, Dot } from 'components/Dots'
import BillingAccountFormEssentialStep from '../BillingAccountFormEssentialStep'
import BillingAccountFormAddressStep from '../BillingAccountFormAddressStep'
import BillingAccountFormPaymentStep from '../BillingAccountFormPaymentStep'

import sMarg from 'styles/modules/margins.scss'

export default class BillingAccountForm extends Component {
  state = {
    step: 0,
    steps: [
      {
        Component: props => <BillingAccountFormEssentialStep prev={this.onCancel} {...props} />,
        heading: 'Your new billing account is coming right up.',
        subHeading:
          'So we can get this started, we just need a few company details from you as per the fields below.',
      },
      {
        Component: props => <BillingAccountFormAddressStep prev={this.prevStep} {...props} />,
        heading: 'Your new billing account is coming right up.',
        subHeading:
          'We’re making progress, but we just need a few extra details from you as per the fields below. (Note: We cannot accept PO box, the address has to be your physical address)',
      },
      {
        Component: props => <BillingAccountFormPaymentStep prev={this.prevStep} {...props} />,
        heading: 'This is the part we love, where you pay us!',
        subHeading:
          "We accept either Credit Card or Direct Debit. Let us know your Credit Card or Direct Debit details below. The good news you won't have to worry about your bill again as it will be automatically taken from your designated credit card or nominated bank account monthly.",
      },
    ],
  }

  onCancel = () => {
    // delete temp billing account if not finished?
    this.props.onCancel() // modalCancel
  }

  nextStep = () => {
    const { step } = this.state
    this.setState({ step: step + 1 })
  }

  prevStep = () => {
    const { step } = this.state
    this.setState({ step: step - 1 })
  }

  submit = formData => {
    const { step, steps } = this.state
    const {
      afterSubmit,
      clearSubmitErrors,
      createBillingAccount,
      updateBillingAccount,
      change,
    } = this.props

    if (step === steps.length - 2) {
      if (formData.ban) {
        return updateBillingAccount(formData).then(() => this.nextStep())
      }

      return createBillingAccount(formData).then(({ action }) => {
        change('ban', action.payload.data.ban)
        this.nextStep()
      })
    }

    if (step === steps.length - 1) {
      return afterSubmit() // modalConfirm
    }

    this.nextStep()
    clearSubmitErrors()
  }

  render() {
    const { steps, step } = this.state
    const { handleSubmit, isEdit, updateBillingAccount, setHeadings } = this.props

    const currentStep = steps[step]

    setHeadings && setHeadings(currentStep.heading, currentStep.subHeading)

    return isEdit ? (
      <div style={{ padding: '2rem', background: 'white' }}>
        <Form onSubmit={handleSubmit(updateBillingAccount)}>
          {steps.map(step => (
            <step.Component {...this.props} prev={undefined} />
          ))}
        </Form>
      </div>
    ) : (
      <>
        <Dots className={sMarg.mb60to30}>
          {steps.map((undefined, idx) => (
            <Dot key={idx} active={step === idx} />
          ))}
        </Dots>

        <Form onSubmit={handleSubmit(this.submit)}>
          <currentStep.Component {...this.props} />
        </Form>
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountForm/BillingAccountForm.jsx